enum CreationToolWatermarkPosition {
    TopLeft = 'CT_WATERMARK_TOP_LEFT',
    TopRight = 'CT_WATERMARK_TOP_RIGHT',
    BottomLeft = 'CT_WATERMARK_BOTTOM_LEFT',
    BottomRight = 'CT_WATERMARK_BOTTOM_RIGHT',
}

namespace CreationToolWatermarkPosition {
    /**
     * Returns all watermark positions.
     */
    export function all(): CreationToolWatermarkPosition[] {
        return [
            CreationToolWatermarkPosition.BottomRight,
            CreationToolWatermarkPosition.BottomLeft,
            CreationToolWatermarkPosition.TopLeft,
            CreationToolWatermarkPosition.TopRight,
        ]
    }

    /**
     * Returns the degress that the staircase svg icon should be rotated byt.
     */
    export function rotation(position: CreationToolWatermarkPosition): number {
        switch (position) {
            case CreationToolWatermarkPosition.BottomRight:
                return 270
            case CreationToolWatermarkPosition.BottomLeft:
                return 0
            case CreationToolWatermarkPosition.TopLeft:
                return 90
            case CreationToolWatermarkPosition.TopRight:
                return 180
        }
    }
}

export default CreationToolWatermarkPosition
